export enum headerTypes {
  SENDER = "history.sender",
  DESTINATION = "history.destination",
  STATUS = "history.status",
  CREATED_AT = "home.sent",
  UPDATED_AT = "home.delivered"
}
